import { useMemo } from "react";
import { useLocation } from "react-router-dom";

// A custom hook that builds on React Router useLocation
// to parse a query string.
export default function useUrlQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
